module.exports = __webpack_public_path__ + "static/negativLanding-652ab52b6b831185c5cd352494feeb0e.jpg";